import {useEffect, useState} from 'react';
import {useHistory} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {Box, Button, Container, Dialog, DialogTitle, Divider, makeStyles, Theme} from '@material-ui/core';
import ParticipantsInvitingPath from '../../experienceBuilder/pre-recorded/invitingPath';
import CustomSnackBar from './component/CustomSnackBar';
import {
  addNewParticipants,
  getSessionIdByCode,
  getSessionParticipants
} from '../../../../../store/actions/creator/creatorExperienceManager';
import {updateUserMetricsValue} from '../../../../../store/actions/auth/auth';
import {updateUserMetrics} from "../../../../../store/actions/creator/creatorExperienceBuilder";
import ParticipantLists from "../../../participant/list/IndexPage";

const useStyles = makeStyles((theme: Theme) => ({
  closeButton: {
    color: theme.palette.grey[500],
    fontFamily: 'roboto-bold',
    width: 32,
    height: 32
  },
  closeBtnIcon: {
    color: '#212D4080',
    width: 32,
    height: 32,
    fontFamily: 'roboto-bold'
  },
  spacinggap: {
    paddingTop: theme.spacing(10)
  },
  donebtn: {
    textTransform: 'none',
    boxShadow: 'none',
    borderRadius: 6,
    backgroundColor: '#0179EE',
    width: 91,
    height: 37,
    fontSize: 14,
    fontFamily: 'roboto-regular'
  },
  modalBtn: {
    width: 80,
    height: 36,
    fontFamily: 'roboto-regular',
    textTransform: 'none',
    fontSize: 16,
    marginLeft: 14,
  },
  header: {
    color: '#606B76',
    fontFamily: 'Spartan-bold',
    fontSize: 24,
    paddingLeft: 17,
    paddingBottom: 7
  }
})
);

export default function ParticipantsInvite(props: any) {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const participants = useSelector((state: any) => state.experience.participants);
  const session_code = props.match.params.session_code;

  const [snackAlertMsg, handleAlertMsg] = useState('');
  const [isShownSnackAlert, handleShownSnackAlert] = useState(false);
  const [snackAlertType, handleSnackAlertType] = useState("success");
  const [isShownAddLoading, handleShownAddLoading] = useState(false);
  const [isPreRecorded, setIsPreRecorded] = useState(false);
  const [emails, setEmails] = useState<string[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [fromList, setFromList] = useState(false);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";
  const { userMetrics } = useSelector((state: any) => state.creatorExperienceBuilder);
  const { updateBraintrustMetrics, addParticipantList } = userMetrics;

  useEffect(() => {
    if (participants && participants.session && participants.session.session_type) {
      if (participants.session.session_type === 'ASYNC' || participants.session.session_type === 'REELS') {
        setIsPreRecorded(true)
      }
    }
  },[participants]);


  useEffect(() => {
    if (!participants) {
      const request = {
        session_code: session_code,
      };
      dispatch(getSessionParticipants(apolloClient.client, request, ()=>{}));
    }
  },[]);

  const hideSnackAlert = () => {
    handleAlertMsg('');
    handleShownSnackAlert(false);
  };

  const getDetailParticipants = () => {
    const request = {
      session_code: session_code,
    };
    dispatch(getSessionParticipants(apolloClient.client, request, () => {}));
  };

  const handleInviteDone = (emails: any, isDone: boolean) => {
    setEmails([]);
    dispatch(updateUserMetrics('listsParticipants', []));
    if (!emails.length) return;
    handleShownAddLoading(true);
    setFromList(false);
    const participant: any = [];
    emails.forEach((row: any) => {
      const arrayTag: any = [];
      if (row.tags) {
        const itemTags = row.tags.split(',');
        if (itemTags && itemTags.length > 0) {
          itemTags.map((t: any) => {
            if (t && t.trim()) {
              arrayTag.push({ tag_name: t.trim() })
            }
          })
        }
      }
      participant.push({email: row.email, tags: arrayTag, is_csv: row.is_csv});
    });

    let session_id;
    if (participants === null) {
      dispatch(getSessionIdByCode(apolloClient.client, session_code, (res: any) => {
        if (res) session_id = res.session.session_id;
      }));
    } else {
      session_id = participants.session.session_id;
    }
    if (session_id) {
      dispatch(addNewParticipants(apolloClient.client, parseFloat(session_id), participant, [], (res: any) => {
        if (res) {
          if (updateBraintrustMetrics) {
            dispatch(updateUserMetricsValue(apolloClient.client, { user_id: loginUserData.user_id, metrics_type: "BRAINTRUST_USES" }));
            dispatch(updateUserMetrics('updateBraintrustMetrics', false));
          }
          getDetailParticipants();
          const { status, message } = res;
          handleAlertMsg(message);
          handleSnackAlertType(status ? "success" : "error");
          handleShownSnackAlert(true);
          handleShownAddLoading(false);
          isDone && history.go(-1);
        } else {
          handleShownAddLoading(false);
        }
      }));
    } else {
      handleAlertMsg('Experience is not available anymore. Please select an experience again.');
      handleSnackAlertType("error");
      handleShownSnackAlert(true);
      handleShownAddLoading(false);
    }
  };

  const handleAlertInvalidEmail = () => {
    handleAlertMsg("This Email is already taken. Try with another one.");
    handleSnackAlertType("error");
    handleShownSnackAlert(true);
  };

  const handleAddEmail = (email: string) => {
    setEmails(emails => [...emails, email]);
  };

  const handleDeleteEmail = (index: number) => {
    setEmails(emails => emails.filter(({}, _index) => _index !== index))
  };

  const handleEmailAdded = () => {
    if (emails.length) {

    }
    setEmails([]);
  };

  const confirmModal = () => {
    setShowModal(false);
    history.go(-1);
  };

  return (
    <>
      {addParticipantList ? (
        <ParticipantLists onActionBtnClicked={() => setFromList(true)}/>
      ) : (
        <Container maxWidth="lg">
          <div className={classes.spacinggap}/>
          <Box display="flex" justifyContent="center" flexDirection="column" alignItems="center">
            <ParticipantsInvitingPath
              isPreRecorded={isPreRecorded}
              isParticipantInvite
              onAddEmail={handleAddEmail}
              onDeleteEmail={handleDeleteEmail}
              onEmailAdded={handleEmailAdded}
              sentInviteDone={handleInviteDone}
              alertInvalidEmail={handleAlertInvalidEmail}
              isAddLoading={isShownAddLoading}
              currentSessionCode={session_code}
              fromList={fromList}
            />
          </Box>
          <CustomSnackBar type={snackAlertType} message={snackAlertMsg} open={isShownSnackAlert} onClose={hideSnackAlert} />
          <Dialog
            open={showModal}
            onClose={() => setShowModal(false)}
            aria-labelledby="confirm-dialog"
          >
            <DialogTitle id="confirm-dialog">
              <span className={classes.header}>Wait</span>
            </DialogTitle>
            <Divider />
            <Box m={4}>
              <div>Do you mean to leave without inviting participants?</div>
              <div style={{ paddingTop: 15 }}>If not, please click “No” and then click the Add button to invite them.</div>
            </Box>
            <Box mt={3} mb={3} mr={2} display='flex' justifyContent='flex-end'>
              <Button onClick={confirmModal} variant="contained" color='primary' className={classes.modalBtn}>
                Yes
              </Button>
              <Button onClick={() => setShowModal(false)} variant="contained" size='small' className={classes.modalBtn}>
                No
              </Button>
            </Box>
          </Dialog>
        </Container>
      )}
    </>
  )
}